(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_product-details"] && !Shopify.designMode) return;
  try {
    const zoaeStickyDetailsSelector = '.product-information .product-details.sticky-content--desktop';
  const zoaeStickyDetailsDesktop = window.matchMedia('(min-width: 750px)');
  const zoaeStickyDetailsObserved = new WeakSet();

  function zoaeStickyDetailsHeaderHeight() {
    const bodyStyles = getComputedStyle(document.body);
    const groupHeight = parseFloat(bodyStyles.getPropertyValue('--header-group-height'));
    const headerHeight = parseFloat(bodyStyles.getPropertyValue('--header-height'));

    if (Number.isFinite(groupHeight) && groupHeight > 0) return groupHeight;
    if (Number.isFinite(headerHeight) && headerHeight > 0) return headerHeight;
    return 0;
  }

  function zoaeUpdateStickyDetailsPosition(details) {
    if (!zoaeStickyDetailsDesktop.matches) {
      details.style.removeProperty('--zoae-details-sticky-top');
      return;
    }

    const headerHeight = zoaeStickyDetailsHeaderHeight();
    const viewportHeight = window.innerHeight;
    const detailsHeight = details.getBoundingClientRect().height;
    const configuredFollowDistance = Number.parseFloat(details.dataset.stickyFollowDistance || '16');
    const bottomGap = Number.isFinite(configuredFollowDistance) ? Math.max(0, configuredFollowDistance) : 16;
    const availableHeight = viewportHeight - headerHeight - bottomGap;

    const stickyTop =
      detailsHeight <= availableHeight
        ? headerHeight
        : viewportHeight - detailsHeight - bottomGap;

    details.style.setProperty('--zoae-details-sticky-top', `${Math.min(headerHeight, stickyTop)}px`);
  }

  const zoaeStickyDetailsResizeObserver = new ResizeObserver((entries) => {
    for (const entry of entries) {
      zoaeUpdateStickyDetailsPosition(entry.target);
    }
  });

  function zoaeSetupStickyDetails() {
    document.querySelectorAll(zoaeStickyDetailsSelector).forEach((details) => {
      if (!zoaeStickyDetailsObserved.has(details)) {
        zoaeStickyDetailsObserved.add(details);
        zoaeStickyDetailsResizeObserver.observe(details);
      }

      zoaeUpdateStickyDetailsPosition(details);
    });
  }

  function zoaeRefreshStickyDetails() {
    requestAnimationFrame(zoaeSetupStickyDetails);
  }

  zoaeSetupStickyDetails();
  window.addEventListener('resize', zoaeRefreshStickyDetails, { passive: true });
  document.addEventListener('shopify:section:load', zoaeRefreshStickyDetails);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ai_gen_block_4626118"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('zoeder-newsletter-popup')) {
    class ZoederNewsletterPopup extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.dialog = this.querySelector('.zn-dialog');
        this.tabWrap = this.querySelector('.zn-tab-wrap');
        this.tab = this.querySelector('.zn-tab');
        this.key = this.dataset.storageKey;
        this.session = 'zoae-newsletter-tab-hidden';
        this.dismissalKey = 'zoae-newsletter-dismissed';
        this.editor = this.dataset.editor === 'true';
        this.subscribed = this.dataset.subscribed === 'true' || this.read('localStorage', this.key + '-subscribed') === 'true';
        this.tabDismissed = !this.editor && this.read('sessionStorage', this.session) === 'true';
        this.querySelector('.zn-close').addEventListener('click', () => this.close(), options);
        this.tab.addEventListener('click', () => this.open(), options);
        this.querySelector('.zn-tab-dismiss')?.addEventListener('click', event => {
          event.preventDefault();
          event.stopPropagation();
          this.tabDismissed = true;
          this.write('sessionStorage', this.dismissalKey, 'true');
          this.write('sessionStorage', this.session, 'true');
          this.syncTab();
        }, options);
        this.dialog.addEventListener('cancel', event => { event.preventDefault(); this.close(); }, options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
        }, options);
        this.dialog.addEventListener('close', () => this.afterClose(), options);
        document.addEventListener('open-newsletter-popup', () => this.open(), options);
        document.addEventListener('shopify:block:select', event => {
          if (this.contains(event.target) || event.target === this) { this.tabDismissed = false; this.open(); }
        }, options);
        const success = this.querySelector('.zn-success');
        const errors = this.querySelector('.zn-error');
        if (success) {
          this.subscribed = true;
          this.write('localStorage', this.key + '-subscribed', 'true');
          this.open();
          return;
        }
        if (errors) { this.open(); return; }
        if (this.subscribed && this.dataset.hideSubscribed === 'true' && !this.editor) return;
        if (this.editor || this.dataset.pageType === 'product' || this.dataset.pageType === 'cart' || this.read('sessionStorage', this.dismissalKey) === 'true' || (this.dataset.firstVisit === 'true' && this.read('localStorage', this.key) === 'true')) {
          this.syncTab();
          return;
        }
        this.timer = setTimeout(() => this.open(), Number(this.dataset.delay || 5) * 1000);
      }
      read(storage, key) { try { return window[storage].getItem(key); } catch { return null; } }
      write(storage, key, value) { if (!this.editor) { try { window[storage].setItem(key, value); } catch {} } }
      open() {
        clearTimeout(this.timer);
        if (this.dialog.open || !this.isConnected) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        this.tabWrap.hidden = true;
        this.tab.setAttribute('aria-expanded', 'true');
        if (this.dataset.lockScroll === 'true') {
          this.previousOverflow = document.body.style.overflow;
          document.body.style.overflow = 'hidden';
        }
        this.header = document.querySelector('#header-group');
        if (this.dataset.hideHeader === 'true' && this.header) {
          this.previousVisibility = this.header.style.visibility;
          this.header.style.visibility = 'hidden';
        }
        this.write('localStorage', this.key, 'true');
        this.dialog.querySelector('.zn-input')?.focus({ preventScroll: true });
      }
      close() { if (this.dialog.open) this.dialog.close(); }
      afterClose() {
        this.write('sessionStorage', this.dismissalKey, 'true');
        this.restorePage();
        this.tab.setAttribute('aria-expanded', 'false');
        this.syncTab();
        if (!this.tabWrap.hidden && this.tab.getClientRects().length) this.tab.focus({ preventScroll: true });
        else if (this.previousFocus?.isConnected) this.previousFocus.focus({ preventScroll: true });
      }
      restorePage() {
        if (this.previousOverflow !== undefined) { document.body.style.overflow = this.previousOverflow; this.previousOverflow = undefined; }
        if (this.header && this.previousVisibility !== undefined) { this.header.style.visibility = this.previousVisibility; this.previousVisibility = undefined; }
      }
      syncTab() {
        this.tabWrap.hidden = this.dataset.tabEnabled !== 'true' || this.dialog.open || this.tabDismissed || (!this.editor && this.subscribed && this.dataset.hideSubscribed === 'true');
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.controller?.abort();
        this.restorePage();
        if (this.dialog?.open) this.dialog.close();
      }
    }
    customElements.define('zoeder-newsletter-popup', ZoederNewsletterPopup);
  }
  } catch(e) { console.error(e); }
})();

})();
